import { format } from 'date-fns'
import locales from 'utils/dateFns/locales'

export default function (date, formatStr = 'PP') {
  return format(date, formatStr, {
    locale: locales[global.__localeId__], // or global.__localeId__
  })
}
